import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { InvestigationChecklistStepEntity } from '../../../domain/entities/investigation-checklist-step.entity';

export interface GetInvestigationChecklistStepsQuery { investigationId: string; }
export interface GetInvestigationChecklistStepsResult { checklistSteps: InvestigationChecklistStepEntity[]; }

@Injectable({ providedIn: 'root' })
export class GetInvestigationChecklistStepsUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetInvestigationChecklistStepsQuery): Observable<GetInvestigationChecklistStepsResult> {
    this._state.setLoadingChecklistSteps(true);
    this._state.setErrorChecklistSteps(null);
    return this._repository.getChecklistSteps(query.investigationId).pipe(
      tap((steps) => {
        this._state.setChecklistSteps(steps);
        this._state.setLoadingChecklistSteps(false);
      }),
      map((steps) => ({ checklistSteps: steps })),
      catchError((error) => {
        this._state.setErrorChecklistSteps(error.message || 'Failed to load checklist steps');
        this._state.setLoadingChecklistSteps(false);
        return throwError(() => error);
      }),
    );
  }
}
